import React, { FunctionComponent, ReactElement } from 'react';

type StatusProps = {
    isActive: boolean;
}

const Status: FunctionComponent<StatusProps> = (props: StatusProps): ReactElement => {
    const { isActive } = props;

    return (
        <span className='status-container' data-testid='status-container' >
            <span className={`status-${isActive ? 'active' : 'inactive'}`} />
        </span>
    );
};

export default Status;
